import React from 'react';

interface FooterProps {
  t: any;
}

const Footer: React.FC<FooterProps> = ({ t }) => {
  return (
    <footer className="bg-gray-800 text-white py-1.5 md:py-2 sm:py-4 flex-shrink-0 mt-auto">
      <div className="w-full px-3 md:px-4 text-center">
        <p className="text-xs md:text-sm">{t('footer.copyright')}</p>
        <p className="text-xs text-gray-400 mt-0.5">{t('footer.powered')}</p>
      </div>
    </footer>
  );
};

export default Footer;